import { useLang } from "@/context/LangContext";
import { STRINGS } from "@/i18n";

const PHOTOS = [
  { src: "/images/g8.webp", alt: "Mahogany — olive lace mirror selfie" },
  { src: "/images/new1.jpeg", alt: "Mahogany — two long braids, seated" },
  { src: "/images/g7.jpeg", alt: "Mahogany — black top, soft curls" },
  { src: "/images/mahogany.webp", alt: "Mahogany — by the door, ponytail" },
  { src: "/images/new2.webp", alt: "Mahogany — long braids, car selfie" },
  { src: "/images/g6.jpeg", alt: "Mahogany — heart set, at her station" },
  { src: "/images/towel.jpg", alt: "Fresh towel, candle and blooms on the table" },
  { src: "/images/table.jpg", alt: "Mocha's professional massage table and fresh setup" },
  { src: "/images/oils.jpg", alt: "Mocha's shelf of hand-labeled oils" },
];

export default function Gallery() {
  const { lang } = useLang();
  const t = STRINGS[lang];
  return (
    <section data-testid="gallery-section" className="py-16 border-t border-white/10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 mb-8 flex flex-col md:flex-row md:items-end justify-between gap-4">
        <div>
          <span className="mono-lbl text-xs text-[#a4133c] tracking-[0.2em] uppercase">{t.gallery.label}</span>
          <h2 className="serif-disp text-3xl md:text-4xl font-light mt-2">{t.gallery.title}</h2>
        </div>
        <p className="text-neutral-500 text-xs font-light max-w-xs">{t.gallery.sub}</p>
      </div>
      <div
        data-testid="gallery-strip"
        className="flex gap-4 overflow-x-auto px-6 pb-4 snap-x snap-mandatory [scrollbar-width:thin] [scrollbar-color:#800f2f_transparent]"
      >
        {PHOTOS.map((p, i) => (
          <div
            key={p.src}
            data-testid={`gallery-img-${i}`}
            className="snap-start shrink-0 w-52 md:w-64 aspect-[3/4] rounded-xl overflow-hidden border border-white/10 hover:border-[#a4133c]/60 transition-colors relative group"
          >
            <img
              src={p.src}
              alt={p.alt}
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0b090a]/50 via-transparent to-transparent" />
          </div>
        ))}
      </div>
    </section>
  );
}
